// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */

export type CrmDomainDomainAdviseursDirectePostVerzending =
  (typeof CrmDomainDomainAdviseursDirectePostVerzending)[keyof typeof CrmDomainDomainAdviseursDirectePostVerzending];

export const CrmDomainDomainAdviseursDirectePostVerzending = {
  Adviseur: 'Adviseur',
  AdviseurEnRelatie: 'AdviseurEnRelatie',
  Relatie: 'Relatie',
} as const;
